/* eslint-disable react/prop-types */
/** @jsxImportSource @emotion/react */

import { Loading } from '@nike/nike-design-system-icons';
import { keyframes } from '@emotion/react';

const LoadingAnimation = ({ size }) => {
  const rotate = keyframes`100% { transform: rotate(360deg) }`;

  return (
    <div css={{ left: '50%', position: 'absolute', top: '50%', transform: 'translate(-50%, -50%)' }}>
      <Loading
        css={{
          animation: `${rotate} 1s linear infinite`
        }}
        size={size}
      />
    </div>
  );
};

export default LoadingAnimation;
